module.exports = __webpack_public_path__ + "static/media/team_demo.a6c0bfc5.png";